<template>
  <div class="add_note">
    <!-- Popup Model - for select batch number in plants -->
    <vs-popup classContent="popup-example add__plants_batch" title="Add Note" :active.sync="is_add_note_popup_active">
      <div class="note__textarea">
        <vs-textarea v-model="addLabNote.note" height="100px" placeholder="Enter Note" v-validate="'required'" name="Note" data-vv-validate-on="blur" />
        <span class="text-danger text-sm" v-show="errors.has('Note')">{{ errors.first('Note') }}</span>
      </div>

      <!-- footer action btn -->
      <div class="footer text-right">
        <vs-button class="mt-2 text-sm p-3" color="danger" type="filled" @click="$emit('update:is_note_popup_open', false)"> Close </vs-button>

        <button class="mt-2 ml-2 text-sm vs-component vs-button vs-button-primary vs-button-filled p-3" @click="updateLabtestNote" :disabled="!validateForm">Add</button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AddNote',

  props: {
    is_note_popup_open: Boolean,
    addLabNote: {
      labTestId: Number,
      note: String
    }
  },

  computed: {
    // validate form
    validateForm() {
      return !this.errors.any()
    },

    // close the poup
    is_add_note_popup_active: {
      get() {
        return this.is_note_popup_open
      },
      set(val) {
        this.$emit('update:is_note_popup_open', val)
      }
    }
  },
  methods: {
    ...mapActions('lab_test', { insert_lab_test_note: 'addLabTestNote' }),

    async updateLabtestNote() {
      if (!(await this.$validator.validate())) {
        return false
      }

      const data = {
        id: this.addLabNote.labTestId,
        note: this.addLabNote.note
      }

      try {
        const { message } = await this.insert_lab_test_note(data)

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.$root.$emit('updateLabTestList')
        this.$emit('update:is_note_popup_open', false)
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  beforeRouteLeave(_, __, next) {
    this.is_note_popup_open = false
    next()
  }
}
</script>

<style></style>
